import useJwt from '@/auth/jwt/useJwt'

export default class PlanService {
  // eslint-disable-next-line class-methods-use-this
  list() {
    return useJwt.get('/plans')
  }
}
